module.exports = __webpack_public_path__ + "static/media/burger-3.ee21aacb.jpg";